/**
 * 为vuetify的data-table组件在高度超出视窗时，固定底部横向滚动条
 * 需要在data-table上增加 ref table使用
 * 默认监听为items的变化，如果不是items变化，需要在外部手动调用scrollBarFixedHandle
 */

function _scrollBarFixedHandle(el) {
  if (!el) return
  const tableBodyWrapDom = el.querySelector('.v-data-table__wrapper')
  const tableBodyDom = el.querySelector('tbody')
  // top为dom上侧距离可视窗口顶部的值
  const { top: tableBodyWrapDomTop } = tableBodyWrapDom.getBoundingClientRect()
  const { bottom: tableBodyDomBottom } = tableBodyDom.getBoundingClientRect()
  if (
    tableBodyWrapDomTop >= window.innerHeight || // 表在视窗下方不可见区域
    (tableBodyDomBottom > 0 && tableBodyDomBottom <= window.innerHeight) || // 视窗内已经可以看到最后一条数据下的滚动条
    tableBodyWrapDom.classList.contains('is-scrolling-none') // 无滚动条
  ) {
    // 不做任何更改
    tableBodyWrapDom.style.height = 'unset'
    tableBodyWrapDom.style.marginBottom = 'unset'
  } else {
    // 窗口高度 - 列表距顶部值 且 不超过自身实际值
    let wrapHeight = Math.min(
      window.innerHeight - tableBodyWrapDomTop,
      tableBodyDom.offsetHeight,
    )
    tableBodyWrapDom.style.height = wrapHeight + 'px'
    // 需要用marginBottom填充，以保持列表原有高度，避免页面的纵向滚动条变化导致页面滚动的不流畅
    tableBodyWrapDom.style.marginBottom =
      tableBodyDom.offsetHeight - wrapHeight + 'px'
  }
}

export default {
  mounted() {
    this.$refs.table.handleFixedMousewheel = function () {} // 观察源码发现，此方法会使得在right-fixed上滚动同时，wrapper也滚动
    // 监听事件
    document.addEventListener('scroll', this.scrollBarFixedHandle)
    window.addEventListener('resize', this.scrollBarFixedHandle)
  },
  destroyed() {
    // 在组件销毁时取消监听
    document.removeEventListener('scroll', this.scrollBarFixedHandle)
    window.removeEventListener('resize', this.scrollBarFixedHandle)
  },
  watch: {
    items() {
      // 当列表数据源发生变化时，再次触发
      this.$nextTick(this.scrollBarFixedHandle)
    },
    disabled() {
      // 当列表数据源发生变化时，再次触发
      this.$nextTick(this.scrollBarFixedHandle)
    },
  },
  methods: {
    scrollBarFixedHandle() {
      _scrollBarFixedHandle(this.$el)
    },
  },
  activated() {
    this.scrollBarFixedHandle()
  },
}
